import {usePostReferer } from '../../hook/useEditPost'
import {PercentageBar} from '@octavius-rocks/ui'
import {formatShortenNumber} from '../../utils/format'
import {useStyles} from "./PostRefererWidget.styles";

export default ({postId})=>{
    const styles = useStyles()
    const list = usePostReferer(postId)
    const pageviews = list.reduce((prevValue, currentValue)=> prevValue + currentValue.hits, 0)
    return <ul>
        {list.map(({referer_domain, hits}, i)=>{
            const percent = Math.ceil((hits/pageviews)*100)
            return <PercentageBar
                label={referer_domain}
                title={`${formatShortenNumber(hits)} Events`}
                key={referer_domain}
                percentage={percent}
                className={styles.item}
            />
        })}
    </ul>
} 